<a [href]="href" [target]="target">
  <button [ngClass]="class">@if (icon) {
    <fa-icon [ngClass]="iconPadding ? 'p-button-icon-left' : ''" [icon]="icon"></fa-icon>
  }
  <span class="p-button-label">
    <ng-content></ng-content>
  </span>
</button>
</a>